import { html } from "https://cdn.jsdelivr.net/npm/lit-element@4.1.1/+esm";
import { DivContainer } from "./fields.js";

export class AdministratorPersonneMorale extends DivContainer {
	static className = "AdministratorPersonneMorale";
	
  	constructor() {
	    super();
	    this.content = () => html`
		<row-wrapper>
			<text-field label="Nombre d'exercices *" required name="number_of_exercises" disable-autocomplete></text-field>
		</row-wrapper>
		<row-wrapper>
			<date-field label="Date de fin d'exercice *" required name="date_end_exercises"></date-field>
		</row-wrapper>
		<row-wrapper>
			<text-field label="Dénomination *" required name="denomination"></text-field>
		</row-wrapper>
		<row-wrapper>
			<select-from-api label="Forme juridique *" api-url="${window.APP_URL.api.legalForm}" required value="0"
				null-option-text="Forme Juridique" null-option-value="0" name="id_personne_morale_legal_form"></select-from-api>
		</row-wrapper>
		<row-wrapper>
			<text-field label="Adresse *" required label="address" name="address"></text-field>
		</row-wrapper>
		<autocomplete-ville></autocomplete-ville>
        <row-wrapper>
            <text-field label="Lieu d'immatriculation (RCS) *" required name="registration_location"></text-field>
        </row-wrapper>
        <rcs-number-field label="Numéro de RCS *" required></rcs-number-field>
        <row-wrapper>
            <text-field label="Représentant permanent *" required name="permanent_representative"></text-field>
        </row-wrapper>
	    `;
	}
	
	isTransient (){
		return false;
	}
}

customElements.define ("administrator-personne-morale", AdministratorPersonneMorale);
